import { Button } from "@chakra-ui/react";
import { motion } from "framer-motion";

export const MotionButton = motion(Button);
